import { MutableRefObject, useEffect, useRef, useState } from 'react';

interface HookApi {
  stageParentRef: MutableRefObject<Nullable<HTMLDivElement>>;
  canvasDimensions: { width: number; height: number };
}

export const useCanvasDimensions = (): HookApi => {
  const stageParentRef = useRef<Nullable<HTMLDivElement>>(null);

  const [canvasDimensions, setCanvasDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const element = stageParentRef.current;

    if (!element) {
      return;
    }

    const measure = (): void => {
      setCanvasDimensions({
        width: element.offsetWidth || 0,
        height: element.offsetHeight || 0,
      });
    };

    measure();

    const resizeObserver = new ResizeObserver(() => {
      measure();
    });

    resizeObserver.observe(element);

    return (): void => {
      resizeObserver.disconnect();
    };
  }, []);

  return {
    stageParentRef,
    canvasDimensions,
  };
};
